import $ from 'jquery';
import 'bootstrap-sass';
window.$ = window.jQuery = $;
